var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RichTextEditor',{attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"rows":_vm.rows,"qid":_vm.qid,"headings":false,"compact":true},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }